import React from "react";
import ParkEnter from "../../ParkEnter";

const Screen36 = () => {
    return <ParkEnter />;
};

export default Screen36;
